import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef } from 'react';
import Avatar from '../Avatar';
import Link from '../Link';
var AvatarLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Avatar, _extends({
    ref: ref,
    as: Link,
    sx: _objectSpread({
      textDecoration: 'none',
      '&, :visited': {
        opacity: 1,
        transition: 'background-color 200ms ease-in-out, border 200ms ease-in-out, color 200ms ease-in-out'
      },
      ':hover,:focus': {
        backgroundColor: 'transparent',
        borderColor: 'white',
        color: 'contrast'
      }
    }, sx)
  }, rest));
});
AvatarLink.displayName = 'AvatarLink';
export default AvatarLink;